import { defineMessages } from 'react-intl';

type MessageKeys = 'modalTitle' | 'modalCancelButton' | 'noData';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		modalTitle: {
			id: 'rovo-chat.data-sculptor-modal.title',
			defaultMessage: 'Analysis',
			description: 'Title for the data sculptor modal',
		},
		modalCancelButton: {
			id: 'rovo-chat.data-sculptor-modal.cancel',
			defaultMessage: 'Cancel',
			description: 'Label for the cancel button in the data sculptor modal',
		},
		noData: {
			id: 'rovo-chat.data-sculptor-modal.no-data',
			defaultMessage: 'No data',
			description: 'Message for the data sculptor modal when no data is available',
		},
	});

export default message;
